// Smooth open/close for the product-page collapsible rows (Dawn collapsible_tab blocks).
// Listens on the document so rows re-rendered by the theme editor keep working.
// Visitors who prefer reduced motion get the browser's instant toggle.
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Same timing as the theme's --duration-medium and --ease-out-slow.
  const timing = { duration: 300, easing: 'cubic-bezier(0, 0, 0.3, 1)' };

  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.product__accordion summary');
    if (!summary || reduceMotion.matches) return;

    const details = summary.parentElement;
    const content = summary.nextElementSibling;
    if (!content) return;
    event.preventDefault();

    // Measure before cancelling so a tap mid-animation reverses from where the row is now.
    const startHeight = details.offsetHeight;
    details.accordionAnimations?.forEach((animation) => animation.cancel());

    const closing = details.open && !details.classList.contains('is-closing');
    summary.setAttribute('aria-expanded', String(!closing));
    details.style.overflow = 'hidden';

    let endHeight;
    if (closing) {
      details.classList.add('is-closing');
      endHeight = summary.offsetHeight;
    } else {
      details.classList.remove('is-closing');
      details.open = true;
      endHeight = details.offsetHeight;
    }

    const height = details.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, timing);
    const fade = content.animate({ opacity: closing ? [1, 0] : [0, 1] }, timing);
    details.accordionAnimations = [height, fade];

    height.onfinish = () => {
      if (closing) details.open = false;
      details.classList.remove('is-closing');
      details.style.overflow = '';
      details.accordionAnimations = null;
    };
  });
})();
